import { render, staticRenderFns } from "./webview.vue?vue&type=template&id=70367a3a&scoped=true&"
import script from "./webview.vue?vue&type=script&lang=js&"
export * from "./webview.vue?vue&type=script&lang=js&"
import style0 from "./webview.vue?vue&type=style&index=0&id=70367a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70367a3a",
  null
  
)

export default component.exports